import React from 'react';

const PopUp = ({ message}) => {

  return (
    <>{ <div className='popup'>
      <div className='error'>
        <p>{message}</p>
        <span className="iconify" data-icon="zondicons:exclamation-solid"></span>
      </div>
    </div>}
    </>
  );
};

export default PopUp;